import { render, staticRenderFns } from "./country-code-w.vue?vue&type=template&id=132c971b&"
import script from "./country-code-w.vue?vue&type=script&lang=js&"
export * from "./country-code-w.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "country-code-w.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/business/country-code/country-code-w.vue
// module id = 169
// module chunks = 0